var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 43.184-9.253-9.254a2.656 2.656 0 0 0-3.76 0 2.656 2.656 0 0 0 0 3.76l11.147 11.147a2.656 2.656 0 0 0 3.76 0l28.213-28.214a2.656 2.656 0 0 0 0-3.76 2.656 2.656 0 0 0-3.76 0L24 43.183Z",
    fill: "#448533"
  })));
};
export default SvgSuccess;